export default [
    {
        mainImg: '/static/img/pages/product/swift_1.png',
        secondaryImg: '/static/img/pages/product/swift_1.png',
        bg: '/static/img/pages/product/bg/swift_1_bg.jpg',
        name: 'Swift 1',
        param: 'swift_1',
        price: 'В МедиаМаркт за 30 989 руб.',
        link: 'https://www.mediamarkt.ru/item/1356828/acer-swift-sf113-31-p0am-nx-gpner-002-noutbuk',
        title: 'Портативный ноутбук в современном дизайне',
        description: "Стильный дизайн премиум-класса с функциональностью для повседневных задач. Мощный процессор, высокая продуктивность, долгое время автономной работы и быстрый запуск. Этот ноутбук станет незаменимым помощником.",
        features: [
            {
                img: 'case',
                title: 'Металлический<br> корпус'
            },
            {
                img: 'clock',
                title: 'До 10 часов',
                description: 'автономной работы'
            },
            {
                img: 'hd',
                title: '<b>14” Full HD IPS</b>',
                description: 'дисплей'
            },
            {
                img: 'impress',
                title: 'Сканнер<br> отпечатка пальца'
            },
            {
                img: 'windows',
                title: '<b>Windows 10</b>',
                description: 'Домашняя'
            }
        ]
    },
    {
        mainImg: '/static/img/pages/product/spin_1.png',
        secondaryImg: '/static/img/pages/product/spin_1.png',
        bg: '/static/img/pages/product/bg/spin_1_bg.jpg',
        name: 'Spin 1',
        param: 'spin_1',
        price: 'В Эльдорадо за 26 990 руб.',
        link: 'https://www.eldorado.ru/cat/detail/71373454/',
        title: 'Высокая производительность весь день',
        description: 'Наслаждайтесь работой на новом потрясающем ноутбуке Spin 1 \n' +
        'в любом положении благодаря повороту экрана на 360°.',
        features: [
            {
                img: 'case',
                title: 'Металлический<br> корпус'
            },
            {
                img: 'processor',
                title: '<b>Процессоры <br>Intel</b>',
            },
            {
                img: 'hd',
                title: '<b>11,6" FHD IPS</b>',
                description: 'сенсорный дисплей'
            },
            {
                img: 'pen',
                description: 'Стилус в комплекте <br>' +
                'с поддержкой Windows Ink'
            },
            {
                img: 'windows',
                title: '<b>4 положения</b>',
                description: 'для комфортной работы <br>в любых условиях'
            },
            {
                img: '',
                title: '',
                description: ''
            }
        ]
    },
    {
        mainImg: '/static/img/pages/product/swift_3.png',
        secondaryImg: '/static/img/pages/product/swift_3.png',
        bg: '/static/img/pages/product/bg/swift_3_bg.jpg',
        name: 'Swift 3',
        param: 'swift_3',
        price: 'В М.Видео за 43 990 руб.',
        link: 'https://www.mvideo.ru/product-list-page-cls?q=SF314&region_id=1&limit=12',
        title: 'Элегантный и функциональный дизайн',
        description: 'Ноутбук идеально подходит для активного образа жизни. Высокая скорость операций, эффективность и мощность — все в одном устройстве. А его стильная металлическая рамка придает роскошному тонкому ноутбуку элегантность и никого не оставит равнодушным.',
        features: [
            {
                img: 'case',
                title: 'Металлический<br> корпус'
            },
            {
                img: 'clock',
                title: '<b>12 часов</b>',
                description: 'автономной работы'
            },
            {
                img: 'hd',
                title: '<b>14” Full HD IPS</b>',
                description: 'дисплей в корпусе 13.3"'
            },
            {
                img: 'impress',
                title: 'Сканнер отпечатка пальца',
                description: 'с поддержкой Windows Hello'
            },
            {
                img: '',
                title: '',
                description: ''
            },
            {
                img: 'processor',
                title: '<b>Процессоры Intel Core</b>',
                description: '8-го поколения'
            }
        ]
    },
    {
        mainImg: '/static/img/pages/product/swift_5.png',
        secondaryImg: '/static/img/pages/product/swift_5.png',
        bg: '/static/img/pages/product/bg/swift_5_bg.jpg',
        name: 'Swift 5',
        param: 'swift_5',
        price: 'В М.Видео от 86 590 руб.',
        link: 'https://www.mvideo.ru/product-list-page-cls?q=Sf514&region_id=1&limit=12',
        title: 'Новый чемпион в суперлегком весе',
        description: 'Ежедневная работа на этом ноутбуке будет в удовольствие благодаря мощной начинке. Суперкомпактный, суперлегкий и суперстильный - три супер составляющие успеха нового ультрабука Swift 5.',
        features: [
            {
                img: 'case',
                title: '<b>Металлический<br> корпус</b>',
                desccription: 'из сплавов Mg-Li и Mg-Al'
            },
            {
                img: 'clock',
                title: '<b>8 часов</b>',
                description: 'автономной работы'
            },
            {
                img: 'hd',
                title: '<b>14” Full HD IPS</b>',
                description: 'сенсорный дисплей <br>в корпусе 13.3"'
            },
            {
                img: 'weigher',
                title: '<b>970 грамм</b>',
                description: 'вес ноутбука'
            },
            {
                img: 'processor',
                title: '<b>Процессоры Intel Core</b>',
                description: '8-го поколения'
            }
        ]
    },
    {
        mainImg: '/static/img/pages/product/spin_5.png',
        secondaryImg: '/static/img/pages/product/spin_5.png',
        bg: '/static/img/pages/product/bg/spin_5_bg.jpg',
        name: 'Spin 5',
        param: 'spin_5',
        price: 'В М.Видео от 68 490 руб.',
        link: 'https://www.mvideo.ru/product-list-page-cls?q=Acer+Spin5&region_id=1&limit=12',
        title: 'Удобство на 360 градусов',
        description: "Повышенная производительность вычислений и усовершенствованные аудио- и графические технологии. Наслаждайтесь универсальностью этого устройства \n" +
        "и приковывайте взгляды благодаря его стильному дизайну.",
        features: [
            {
                img: 'case',
                title: 'Трансформируемый <br>металлический корпус'
            },
            {
                img: 'clock',
                title: '<b>13 часов</b>',
                description: 'автономной работы'
            },
            {
                img: 'hd',
                title: '13.3” FHD IPS',
                description: 'сенсорный дисплей'
            },
            {
                img: 'pen',
                description: 'Стилус в комплекте <br>с поддержкой Windows Ink'
            },
            {
                img: 'processor',
                title: '<b>Процессоры Intel Core</b>',
                description: '8-го поколения'
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/configs/products.js